namespace app.notification {
    "use strict";

    declare let SystemJS, System;
    
    import Properties = app.support.constants.Properties;
    import AuthService = app.autenticacao.AuthService;
    
    export interface INotification {
        uuid: string;
        type: string;
        name: string;
        content: any;
        receiver: string;
        sender: string;
        read: boolean;
        creationDate: number;
        tenant: string;
        requiredModules: string[];
    }
    
    export class NotificationService {
       
        private worker: SharedWorkerPolyfill;
        
        /** @ngInject */
        public constructor($rootScope: ng.IRootScopeService, $window: ng.IWindowService,
                private $cookies: ng.cookies.ICookiesService, private properties: Properties,
                private authService: AuthService, private $q: ng.IQService, 
                private $ocLazyLoad: oc.ILazyLoad, private stylesLoadingService: app.support.StylesLoadingService
            ) {

            this.worker = new SharedWorkerPolyfill("scripts/event-source-notification.js");
            this.worker.start();
            this.worker.onmessage = (event: MessageEvent): void => {
                let notification: INotification = angular.fromJson(event.data);
                this.authService.getUser().then(user => {
                    if (!notification.tenant || user.lotacao === notification.tenant) {
                        if (notification.requiredModules && notification.requiredModules.length > 0) {
                            this.carregarModulos(notification.requiredModules).then(() => {
                                $rootScope.$broadcast(notification.name, notification);
                            });
                        } else {
                            $rootScope.$broadcast(notification.name, notification);
                        }
                    }
                });
            };
            $window.onbeforeunload = (event: BeforeUnloadEvent) => {
                this.post({type: "close"});
            };
        }
        
        public init(): void {
            let accessToken = this.$cookies.get("access_token");
            
            if (accessToken) {
                this.post({type: "init", accessToken: accessToken, apiUrl: this.properties.apiUrl});
            }
        }
        
        public stop(): void {
            this.post({type: "stop"});
        }
        
        private post(message: Object): void {
            this.worker.postMessage(angular.toJson(message));    
        }

        private carregarModulos(modules: string[]): ng.IPromise<void[]> {
            return this.$q.all(modules.map(module => this.carregarModulo(module)));
        }

        private carregarModulo(module: string): ng.IPromise<void> {
            let context = module.split("/")[0];
            let modulo = module.split("/")[1];

            var defer = this.$q.defer<any>();
            //Realiza a importação dos arquivos dos módulos
            let bundle = `${context}/bundle`;
        
            System.import(bundle).then((loaded) => {
              var newModule = loaded;
              
              if (!loaded.name) {
                  var key = Object.keys(loaded);
                  newModule = loaded[key[0]];
              }
              //Carrega o módulo angular importado
              this.$ocLazyLoad.load(newModule);
            });
            
            var styleUrl = SystemJS.baseURL + context + "/style.css";
            this.$q.all([System.import(bundle), this.stylesLoadingService.loadStyle(styleUrl)]).then(() => {
                console.log("Módulo carregado:", modulo);
                System.import(`${context}/${modulo}`).then((loaded) => {
                    var newModule = loaded;                    
                    if (!loaded.name) {
                        var key = Object.keys(loaded);
                        newModule = loaded[key[0]];
                    }
                    //Carrega o módulo angular importado
                    this.$ocLazyLoad.load(newModule);
                    defer.resolve();
                });
            });
            return defer.promise;
          }
    }
    
    angular
        .module("app.notification")
        .service("notificationService", NotificationService);
}
